export default __webpack_public_path__ + "static/media/young_peoples.cb94410b.png";